import { useContext, useState, useEffect, useCallback } from "react";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { ChatContext } from "./../../context/ChatContext";
import Rooms from "./components/Rooms";
import Messages from "./components/Messages";
import RoomSettings from "./components/RoomSettings";
import authService from "../../services/authService";

const Chat = () => {
  const user = authService.getCurrentUser();

  const [connection] = useContext(ChatContext);

  const [open, setOpen] = useState(false);

  const [rooms, setRooms] = useState([]);
  const [messages, setMessages] = useState([]);

  const [selectedRoom, setSelectedRoom] = useState(null);

  const handleReceive = useCallback(
    async (mounted) => {
      connection.on("ReceiveRoom", (room) => {
        if (mounted)
          setRooms((rooms) => {
            const data = [...rooms];

            const index = data.findIndex((i) => i.id === room.id);

            const item = { ...room };
            item["text_message"] = room.textMessage;
            item["message_id"] = room.messageId;
            item["total_count"] = room.totalCount;

            if (index === -1) {
              data.push(item);
            } else {
              data[index] = item;
            }

            return data;
          });
      });

      connection.on("ReceiveMessage", (message) => {
        const item = { ...message };
        item["sender_id"] = message.senderId;
        item["room_id"] = message.roomId;
        item["parent_id"] = message.parentId;
        item["text_message"] = message.textMessage;
        item["is_read"] = message.isRead;
        item["created_on"] = message.createdOn;
        item["total_count"] = message.totalCount;

        if (mounted) setMessages((messages) => [...messages, item]);
      });
    },
    [connection]
  );

  const handleJoinRoom = async (room) => {
    const updatedRoom = { ...room };
    updatedRoom["user_id"] = user.user_id;

    if (selectedRoom !== null && selectedRoom !== updatedRoom) {
      await connection.invoke("LeaveRoom", selectedRoom);
      setOpen(false);
    }

    await connection.invoke("JoinRoom", updatedRoom);
    setSelectedRoom(updatedRoom);
  };

  useEffect(() => {
    let mounted = true;

    handleReceive(mounted);

    return () => {
      mounted = false;
    };
  }, [handleReceive]);

  const handleSidebar = () => setOpen(!open);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-0">
      <div className="card p-0 flex flex-row h-messages">
        <div className="flex flex-row w-16 lg:w-3/12 border-r">
          <Rooms
            room={selectedRoom}
            rooms={rooms}
            setRooms={setRooms}
            setSelectedRoom={setSelectedRoom}
            joinRoom={handleJoinRoom}
          />
        </div>
        <div className={`flex flex-row ${open ? "w-6/12" : "w-full"}`}>
          {!selectedRoom && (
            <div className="flex flex-col h-full w-full bg-white p-8">
              <div className="h-full flex justify-center items-center overflow-hidden py-4 h-messages">
                <div>
                  <IoChatboxEllipsesOutline className="text-6xl mb-3 mx-auto text-gray-400" />
                  <p className="text-gray-500 text-center">
                    You don't have a message selected
                  </p>
                  <span className="text-center text-gray-400 text-sm">
                    Choose one from your existing messages, or start a new one.
                  </span>
                </div>
              </div>
            </div>
          )}
          {selectedRoom && (
            <Messages
              room={selectedRoom}
              messages={messages}
              setMessages={setMessages}
              setOpen={handleSidebar}
            />
          )}
        </div>
        {selectedRoom && open && (
          <div className="flex w-80 border-l">
            <RoomSettings room={selectedRoom} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Chat;
